import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import { MainHeaderDesktop as View } from '../../components/main-header/desktop/component';

import { MainHeaderContainer as Component } from './component';
import type { IDepsDesktop, TMainHeaderContainerDesktop } from './models';

export const MainHeaderDesktop = createWidgetWithErrorBoundary<
    IDepsDesktop,
    TMainHeaderContainerDesktop
>({
    View,
})(Component);
